import { ROLES, type RoleStrategy } from "@pharmupp/p3-front-commons"
import { practicalInformationFields as fields } from "./practicalInformation.const"

export const practicalInformationFormRoleConf: RoleStrategy<
  Record<string, { disabled?: boolean }>
> = {
  [ROLES.ADHERENT_TEAM]: {
    [fields.counterScreens]: {
      disabled: true,
    },
    [fields.frontParking]: {
      disabled: true,
    },
    [fields.interiorScreens]: {
      disabled: true,
    },
    [fields.lastTurnover]: {
      disabled: true,
    },
    [fields.showcaseScreens]: {
      disabled: true,
    },
    [fields.pharmacyArea]: {
      disabled: true,
    },
    [fields.location]: {
      disabled: true,
    },
  },
}
